const VERSIONS = '20240912'
export default VERSIONS
